import React from 'react'
import UserProviderStats from '../components/stat/UserProviderStat.jsx'
import DeviceStats from '../components/stat/DeviceStat.jsx'

const AgentActivity = () => {
  return (
    <div>
         <DeviceStats/>
      <UserProviderStats/>
     
    </div>
  )
}

export default AgentActivity
